module.exports = __webpack_public_path__ + "html/studio-header_c9f59c904366e8009b8213e4c9d1fc1d.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/studio-header.html
// module id = 1aEF
// module chunks = 154